// Central API client + axios instance.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "wsp_token";
const REFRESH_KEY = "wsp_refresh";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    // Normalise FastAPI 422 detail (array/object) into a readable string so UI code that
    // surfaces error.response.data.detail never crashes when rendered as React child.
    const d = err.response?.data?.detail;
    if (d !== undefined && d !== null && typeof d !== "string") {
      if (Array.isArray(d)) {
        err.response.data.detail = d.map((x) => (x && (x.msg || x)) || "validation error").join(", ");
      } else if (typeof d === "object") {
        err.response.data.detail = d.msg || JSON.stringify(d);
      }
    }
    if (err.response?.status === 401 && !err.config._retry) {
      const refresh = localStorage.getItem(REFRESH_KEY);
      if (refresh) {
        try {
          err.config._retry = true;
          const { data } = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: refresh });
          localStorage.setItem(TOKEN_KEY, data.access_token);
          localStorage.setItem(REFRESH_KEY, data.refresh_token);
          err.config.headers.Authorization = `Bearer ${data.access_token}`;
          return api(err.config);
        } catch {
          localStorage.removeItem(TOKEN_KEY);
          localStorage.removeItem(REFRESH_KEY);
        }
      }
    }
    return Promise.reject(err);
  }
);

export const setAuth = (data) => {
  localStorage.setItem(TOKEN_KEY, data.access_token);
  localStorage.setItem(REFRESH_KEY, data.refresh_token);
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
};

export const hasAuth = () => !!localStorage.getItem(TOKEN_KEY);
